const Menu = [
  // ===== MAIN WORKFLOW =====
  { header: "Main" },
  {
    title: "Home",
    icon: "home",
    name: "Home"
  },
  {
    title: "Admin Transfers",
    icon: "account_balance",
    name: "AdminTransfers"
  },
  {
    title: "Riders Transfers",
    icon: "account_balance_wallet",
    name: "PassengersTransfers",
  },
  {
    title: "Business Transfers",
    icon: "business",
    name: "BusinessTransfers",
  },
  {
    title: "Drivers Transfers",
    icon: "local_taxi",
    name: "DriversTransfers"
  }
];

export default Menu;
